// External deps
import React from 'react';
import PropTypes from 'prop-types';
import { Label, ModalGeneric} from 'ypf-pas-general-ui-components';

// Internal deps
import CustomToolTip from '../CustomTooltip/CustomTooltip';

const ModalUserProfile = ({
    setShowModalUserProfile,
    showModalUserProfile,
    canBeEditMeProfile,
    infoUserLogger,
    primaryAction
}) => {
    const onCloseModalUserProfile = () => {
        setShowModalUserProfile(false);
      };
      const renderLableAndTooltip = (label, text = []) => {
        const uniqueArrayText = text.filter((obj, index, self) => index === self.findIndex((ob) => (
          ob.name === obj.name
        )));
        const joinedText = text.map((e) => e.name).join(', ');
        const maxTextLength = 45;
        if (joinedText?.length > maxTextLength) {
          return (
            <CustomToolTip
              text={uniqueArrayText.map((e) => e.name).join(', ') || ''}
              tooltipClassName="tooltip-margin"
            >
              <Label
                label={label}
                sizeValue="lg"
                value={uniqueArrayText.map((e) => e.name).join(', ') || '-'}
              />
            </CustomToolTip>
          );
        }
        return (
          <Label
            label={label}
            sizeValue="lg"
            value={uniqueArrayText.map((e) => e.name).join(', ') || '-'}
          />
        );
      };
    if(Object.keys(infoUserLogger).length === 0) return null
    return ( 
        <ModalGeneric
        title="Mi perfil"
        size="lg"
        show={showModalUserProfile}
        onHide={onCloseModalUserProfile}
        infoModal
        backdrop="static"
        secondaryActionLabel="Salir"
        secondaryActionVariant="outline-primary"
        secondaryAction={() => onCloseModalUserProfile()}
        primaryActionLabel="Editar perfil"
        primaryActionVariant={!canBeEditMeProfile ? 'secondary' : 'primary'}
        primaryActionDisabled={!canBeEditMeProfile}
        primaryAction={primaryAction}
      >
        <div className="adm-modal-content">
          <Label
            label="ID"
            sizeValue="lg"
            value={infoUserLogger.userName || '-'}
          />
          <Label
            label="Apellido y nombre"
            sizeValue="lg"
            value={`${infoUserLogger.lastName}, ${infoUserLogger.firstName}` || '-'}
          />
          <Label
            label="Email"
            sizeValue="lg"
            value={infoUserLogger.email || '-'}
          />
  
          {renderLableAndTooltip('UUNN', infoUserLogger.uunn.map((unit) => (unit)))}
  
          {renderLableAndTooltip('Rol o Roles', infoUserLogger.roles.map((rol) => (rol)))}
          <Label
            label="Proveedor"
            sizeValue="lg"
            value={infoUserLogger.provider || '-'}
          />
          <Label
            label="CUIT"
            sizeValue="lg"
            value={infoUserLogger.cuit || '-'}
          />
          {renderLableAndTooltip('Grupo o Grupos', infoUserLogger?.groups?.map((g) => g.userGroup))}
          {renderLableAndTooltip('Servicio o Servicios', infoUserLogger.services.map((service) => (service)))}
        </div>
  
      </ModalGeneric>
     );
}
ModalUserProfile.propTypes = {
    setShowModalUserProfile: PropTypes.func,
    showModalUserProfile: PropTypes.bool,
    canBeEditMeProfile: PropTypes.bool,
    primaryAction: PropTypes.func.isRequired,
    infoUserLogger: PropTypes.shape({
      userName: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      uunn: PropTypes.arrayOf([PropTypes.shape({})]),
      roles: PropTypes.arrayOf([PropTypes.shape({})]),
      groups: PropTypes.arrayOf([PropTypes.shape({})]),
      provider: PropTypes.string,
      cuit: PropTypes.string,
      services: PropTypes.arrayOf([PropTypes.shape({})])
    }).isRequired
  };
  ModalUserProfile.defaultProps = {
    setShowModalUserProfile: () => {},
    showModalUserProfile: false,
    canBeEditMeProfile: false
  };  
 
export default ModalUserProfile;